import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { getSourceNomenclature } from 'Utils/nomenclature';
import { getDataSourceById, toUiDataSource } from '../DataSources/datasourcesApi';
import SalesforceObjectDetail from './SalesforceNetwork/ObjectDetail';
import './styles.css';

const objectPath = (dataSourceId, table) =>
  `/metadata/source/${encodeURIComponent(dataSourceId)}/object/${encodeURIComponent(table)}`;

/**
 * One Salesforce object on the profile side (/metadata/source/:dataSourceId/object/:objectName):
 * exploration only, so no object choice — that is the Data Graph's job. The body is shared with
 * the Data Graph's object page.
 */
const SalesforceObjectPage = () => {
  const { dataSourceId, objectName: objectParam } = useParams();
  const objectName = decodeURIComponent(objectParam);
  const history = useHistory();
  const [sourceName, setSourceName] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getDataSourceById(dataSourceId)
      .then((dto) => { if (!cancelled && dto) setSourceName(toUiDataSource(dto).name); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [dataSourceId]);

  return (
    <div className='metadata-page'>
      <div className='metadata-toolbar'>
        <span className='mt-title'>OBJECT DETAIL</span>
        <span className='mt-sep'>|</span>
        <button
          type='button'
          className='metadata-sortbtn'
          data-testid='sf-object-back'
          onClick={() => history.push('/metadata/source/' + encodeURIComponent(dataSourceId))}
        >
          ← Back to {sourceName || 'data source'}
        </button>
      </div>
      <div style={{ flex: 1, overflowY: 'auto', padding: 16, background: '#fff' }}>
        <SalesforceObjectDetail
          dataSourceId={dataSourceId}
          objectName={objectName}
          nouns={getSourceNomenclature('salesforce')}
          onOpenObject={(table) => history.push(objectPath(dataSourceId, table))}
        />
      </div>
    </div>
  );
};

export default SalesforceObjectPage;
